import { ContentFramework } from './types'

export const ContentFrameworkLabels: Record<ContentFramework, string> = {
  [ContentFramework.CEFR]: 'CEFR',
  [ContentFramework.GESE]: 'GESE',
  [ContentFramework.ISE]: 'ISE'
}
